module.exports = __webpack_public_path__ + "static/laptop_intel-3ebac1a27af5386987a365d9f52e71ed.png";